<template>
  <div>
    <v-layout row wrap justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
      <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
            <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Características equipos de monitoreo de atmósferas</h1>    
            <h2 class="animated bounceIn dura-2">Equipo de monitoreo de atmósferas</h2>
      </v-flex>
      <v-flex xs12 sm7 md7 class="animated fadeInUp text-xs-center">
              <v-card color="transparent" flat tile> 
                  <v-window v-model="onboarding">                
                    <v-window-item  v-for="n in length" :key="`card-${n}`">
                      <v-card class="cont_text-slider" color="transparent" flat>
                        <div class="flip-item">
                          <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-2-'+n+'.png')" alt="">
                          <p class="caja_texto" v-html="texto[onboarding]"></p>
                        </div>
                      </v-card>
                    </v-window-item>
                  </v-window>
                  <v-card-actions class="cont_buttons-slider">
                    <v-item-group light v-model="onboarding" class="text-center " mandatory>
                      <v-item v-for="n in length" :key="`btn-${n}`" v-slot:default="{ active, toggle }" >
                        <v-btn :color="vistos[n-1] ? '#ff9955ff' : '#28f7d1ff'" small class="item-button" :input-value="active" icon @click="toggle">
                          <v-icon>mdi-record</v-icon>
                        </v-btn>
                      </v-item>
                    </v-item-group>
                  </v-card-actions>
            </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      length:10, 
      onboarding: 0,
      vistos:Array(10).fill(false), 
      dialogos: [
        '' 
      ],
      texto:[
        'Debe ser <strong>intrínsecamente seguro.</strong> Clase I, División I, Grupos A,B,C,D. <br> Un equipo intrínsecamente seguro es el que <strong>es incapaz de descargar una energía eléctrica o térmica suficiente, en condiciones normales o anormales,</strong> para provocar la ignición de mezclas atmosféricas específicamente peligrosas.',
        'Debe tener protección contra la interferencia electromagnética (EMI) y la interferencia por radiofrecuencia (RFI).',
        'Debe visualizar datos en pantalla con la concentración del gas (%O2, %LEL, CO ppm, H2S ppm y otros gases que apliquen según el sensor instalado) en pantalla auto-iluminada.',
        'Debe disponer de alarma sonora, fácilmente audible (mínimo 85 dB) y visual.',
        'Debe tener una clasificación IP65 (resistente al polvo y la humedad).',
        'Operable en condiciones de temperatura entre -10°C y 40 °C y humedad relativa de 15% a 90%.',
        'Contar con memoria para almacenamiento de datos registrados de gases inflamables, oxígeno y tóxicos, y permitir la impresión de estos.',
        'Que requiera calibración/verificación usando un gas patrón.',
        'Los equipos deberán contar con módulo de bombeo (generación de vacío), sensores para cada uno de los gases que se van a detectar, tubo toma muestra con su manguera para situaciones donde no se puede acceder o se tenga alto riesgo de inhalación de vapores, filtros para retener material particulado y/o humedad.',
        'Debe tener asistencia técnica y mantenimiento en Colombia, con programa de disposición de residuos peligrosos.'
      ],
      items:[
        'Si al momento de hacer la verificación, el equipo presenta error, se debe calibrar inmediatamente sin esperar que se complete el mes.',
        'Cuando se golpee físicamente.',
        'Cuando se expone a altos niveles de contaminantes.',
        'Cuando se realice prueba de gases en atmósferas que contengan siliconas orgánicas, silicatos, compuestos con contenido de plomo que pueda haber desensibilizado el sensor de gas combustible y reducir la capacidad de lectura.'
      ],

    }
  },
    created() {
    this.$set(this.vistos,0,true)
  },
  watch: {
    onboarding(val){
      this.$set(this.vistos,val,true)
    }
  },
}
</script>
<style lang="scss" scoped>
@import '../../sass/globals';
.cont_buttons-slider{
  justify-content: center;
  .item-button{
    width: 15px;
    height: 15px;
  }
}
.flip-item{
  position: relative;
  width: 100%;
  height:auto;
  padding: 10px;
  p{
    text-align: center;
  }
  .pb{
    color: $color-secondary;
    font-family: FontBase-Bold;
  }
  @media screen and (max-width: 330px) {
    img{
      width: 80px;
    }
    
  }
}
.caja_texto{
  background:#ffff;
  padding: 5px 5px 5px 5px;
}
hr {
    height: 2px;
    background-color: $color-complement-one;
    border: none;
    margin-bottom: 1em;
}
@media screen and (max-width: 500px){
.contenido2{
  display: flex;
  flex-direction: column;
  align-items: center;
}
}
.circulos{
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>
